import { saveAs } from 'file-saver';
import JSZip from 'jszip';

function _download(filename, content, isBlob) {
  const castedContent = castContent(filename.split('.').pop(), content);
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    const blob = isBlob ? content : new Blob([castedContent]);
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    const anchor = document.createElement('a');
    anchor.setAttribute('href', castedContent);
    anchor.setAttribute('download', filename);
    anchor.setAttribute('target', '_blank');

    anchor.style.display = 'none';
    document.body.appendChild(anchor);

    anchor.click();

    document.body.removeChild(anchor);
  }

  return true;
}

export function download(filename, content) {
  return _download(filename, content, false);
}

export function downloadBlob(filename, content) {
  return _download(filename, content, true);
}

export async function downloadConfigurationImages(filename, imagesWithName) {
  let zip = new JSZip();
  for (let imageWithName of imagesWithName) {
    zip.file(imageWithName.name.split('/').join(''), imageWithName.image, { createFolders: false, base64: true });
  }

  try {
    const zipResult = await zip.generateAsync({ type: 'blob' });
    saveAs(zipResult, filename);

  } catch (error) {
    console.log(error);
    throw error;
  }
}

/**
* Downloads file by provided reference
* @param uri
* @param name
*/
export function downloadURI(uri, name) {
  const link = document.createElement('a');
  link.download = name;
  link.href = uri;
  if (!link.onclick) window.open(link.href, link.target || '_self');
  else link.click();
}

function castContent(fileExtension, content) {
  if ((content?.tagName || '').toLowerCase() === 'canvas') {
    return content.toDataURL(`image/${fileExtension}`);
  } else if (['csv', 'xls'].includes(fileExtension)) {
    // String to force Excel to use UTF-8 encoding
    return 'data:text/plain; charset=utf-8,' + encodeURIComponent(`\uFEFF${content}`);
  } else if (['py'].includes(fileExtension)) {
    return 'data:text/plain; charset=utf-8,' + encodeURIComponent(b64DecodeUnicode(content));
  } else if (['pdf'].includes(fileExtension)) {
    return URL.createObjectURL(content);
  }
  return content;
}

function b64DecodeUnicode(str) {
  // Going backwards: from bytestream, to percent-encoding, to original string.
  return decodeURIComponent(atob(str).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
}
